import styled from 'styled-components';

import { tokens, mixins } from '@mindtickle/styles/lib';

export const StyledRightSectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  #design-review-btn {
    .custom-dropdown-menu.show {
      z-index: ${mixins.zIndex.POPOVER};
    }
  }
`;

// LOADERS STYLES
export const StyledGlobalHeaderLoader = styled.div`
  padding: 12px 24px;
  display: grid;
  background-color: ${tokens.bgTokens.COLOR_BG_DEFAULT};
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  border-bottom: 1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY};

  .settings-wrp {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
  }
  .logo-wrp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
  }
`;

export const SITE_INFO_STYLES = { height: '22px', width: '80px', marginRight: '16px' };

export const SETTINGS_ACTION_STYLE = { height: '32px', width: '32px' };

export const SITE_THUMBNAIL_STYLES = {
  height: '32px',
  width: '32px',
  borderRadius: '4px',
};
